import { api } from "./clientInstance";

export async function saveTeam(data, method) {
  return api("/user/team", {
    method,
    body: JSON.stringify(data),
  });
}
